import { render, staticRenderFns } from "./VerifyOtpModal.vue?vue&type=template&id=4372813f&scoped=true&"
import script from "./VerifyOtpModal.vue?vue&type=script&lang=js&"
export * from "./VerifyOtpModal.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOtpModal.vue?vue&type=style&index=0&id=4372813f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372813f",
  null
  
)

export default component.exports